.spellWrapper {
  background: var(--color-bg-white);
  border-radius: 2px;
  list-style: none;

  &:has(> .spellCard) {
    display: grid;
    grid-template-rows: auto 1fr;
    grid-template-columns: 1fr;
  }

  .spellSummary {
    position: sticky;
    top: 98px;
    display: grid;
    grid-template-columns: auto 1fr auto;
    border-radius: 2px;

    @media (min-width: 630px) {
      top: 48px;
    }

    &:has(~ .spellCard) {
      border-bottom: 1px solid #dac3a6;
      background-color: #efefe8;
    }

    .checkbox {
      justify-content: center;
      padding-right: 12px;
    }

    .summary {
      color: var(--color-text);
      overflow: hidden;
      cursor: pointer;
      padding: 8px 16px 8px 4px;
      text-decoration: none;

      h4 {
        margin: 0;
        font-size: 16px;
      }

      .levelAndTime {
        font-size: 14px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }

      &:hover:not(.disabled) {
        text-decoration: underline;
        background: var(--color-bg-white);
      }

      &.disabled {
        cursor: default;
      }
    }
  }

  .spellCard {
    grid-column: span 2;
  }
}

.dialog.dialog {
  padding: 16px;

  header {
    padding-bottom: 8px;

    h3 {
      margin: 0;
    }

    button {
      background: var(--color-bg-white);

      &:hover {
        background: #fff;
      }
    }
  }

  .spellCard {
    padding: 0;
    gap: 8px;

    > *:not(:has(> div > div)) {
      background: var(--color-bg-white);
      padding: 8px 16px;
      border-radius: 2px;
    }

    > *:not(:last-child) {
      font-size: 16px;
    }
  }
}
